export var ErrorsEnum;

(function (ErrorsEnum) {
  ErrorsEnum[ErrorsEnum["NameIsAlreadyExists"] = 4005] = "NameIsAlreadyExists";
  ErrorsEnum[ErrorsEnum["PhoneIsAlreadyExists"] = 5000] = "PhoneIsAlreadyExists";
  ErrorsEnum[ErrorsEnum["EmailIsAlreadyExists"] = 5002] = "EmailIsAlreadyExists";
  ErrorsEnum[ErrorsEnum["InvalidOTP"] = 4011] = "InvalidOTP";
  ErrorsEnum[ErrorsEnum["InvalidPIN"] = 4012] = "InvalidPIN";
  ErrorsEnum[ErrorsEnum["AttemptsExpired"] = 4013] = "AttemptsExpired";
  ErrorsEnum[ErrorsEnum["StartsWithZero"] = 1013] = "StartsWithZero";
})(ErrorsEnum || (ErrorsEnum = {}));